var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4129_4419)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4129_4419)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49337 0.742997C9.15547 0.900716 9.78818 1.16302 10.3677 1.52003L11.5856 0.979122L13.0211 2.41453L12.4803 3.63209C12.8374 4.2117 13.0998 4.84459 13.2574 5.50687L14.5 5.98512V8.01512L13.2572 8.49353C13.0994 9.15562 12.8371 9.78833 12.4802 10.3678L13.0211 11.5857L11.5856 13.0212L10.3681 12.4804C9.78848 12.8376 9.1556 13.0999 8.49331 13.2576L8.01503 14.5001H5.98503L5.50663 13.2572C4.84453 13.0995 4.21183 12.8372 3.63234 12.4802L2.41441 13.0212L0.978938 11.5857L1.51972 10.3682C1.16262 9.78856 0.900269 9.15568 0.742563 8.4934L-0.5 8.01515V5.98515L0.74275 5.50678C0.900454 4.84463 1.16277 4.21188 1.51981 3.63237L0.978938 2.41456L2.41438 0.979091L3.63228 1.52C4.21176 1.16299 4.84447 0.900685 5.50656 0.742966L5.98503 -0.499878H8.015L8.49337 0.742997ZM7.029 5.14628L3.72531 6.02384C3.63281 6.0484 3.63281 6.1805 3.72531 6.20506L7.02897 7.08262C7.07847 7.09578 7.12388 7.09578 7.17338 7.08262L10.477 6.20506C10.5695 6.1805 10.5695 6.04843 10.477 6.02384L7.17338 5.14628C7.12391 5.13315 7.07847 5.13315 7.029 5.14628ZM3.35913 7.57915L3.29122 7.61834C3.22166 7.6585 3.18184 7.72747 3.18184 7.80778V8.58572C3.18184 8.66319 3.27003 8.70722 3.33194 8.66062L3.60909 8.45218L3.88628 8.66062C3.94819 8.70718 4.03638 8.66315 4.03638 8.58568V7.80775C4.03638 7.72743 3.99656 7.65847 3.927 7.61831L3.85913 7.57912V6.75787L3.59697 6.68825C3.50234 6.66312 3.42313 6.62009 3.35913 6.56506V7.57915ZM4.55959 6.944V8.30093C4.55933 8.34484 4.5746 8.38743 4.60269 8.42117C4.63078 8.45491 4.6699 8.47764 4.71313 8.48534C7.51056 9.00243 6.69184 9.00243 9.48925 8.48534C9.53248 8.47765 9.5716 8.45492 9.59969 8.42118C9.62779 8.38743 9.64305 8.34484 9.64278 8.30093V6.944L7.30175 7.56587C7.17039 7.60131 7.03199 7.60131 6.90063 7.56587L4.55959 6.944ZM7 2.07678C4.28091 2.07678 2.07663 4.28103 2.07663 7.00012C2.07663 9.71922 4.28088 11.9235 7 11.9235C9.71909 11.9235 11.9233 9.71925 11.9233 7.00012C11.9233 4.28103 9.71909 2.07678 7 2.07678Z",
    fill: "#667085"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4129_4419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4129_4419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.04483300b7a4dfcc94f1048357f70fa3.svg";
export { ForwardRef as ReactComponent };